<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-select v-model="dataForm.userId" filterable clearable placeholder="账户名称">
            <el-option v-for="item in  fundList" :key="item.userId" :value="item.userId" :label="item.deptName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="dataForm.serialNo"
            placeholder="交易流水"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
            <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="交易开始日期"
                    end-placeholder="交易结束日期"
                    :default-time="['00:00:00','23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="getTimes"
                    unlink-panels>
            </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.incomeAndExpensesType" filterable clearable placeholder="收支类型">
            <el-option v-for="item in  incomeTypeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.tradeType" filterable clearable placeholder="交易类型">
            <el-option v-for="item in  payTypeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.chargesId" filterable clearable placeholder="费用名称">
            <el-option v-for="item in  feeTypeList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.childrenChargesId" filterable clearable placeholder="子费用名称">
            <el-option v-for="item in  feeTypeChildrenList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.type" filterable clearable placeholder="类型">
            <el-option v-for="item in  typeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.status" filterable clearable placeholder="状态">
            <el-option v-for="item in  statusList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="dataForm.agreementCode"
            placeholder="借款编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" plain @click="inquire()">{{ $t("query") }}</el-button>
        </el-form-item>
      </el-form>
      <div class="type">
        <!-- <div class="sum_amount">
          <div class="number">32,000.00</div>
          <div class="text">总额/元</div>
        </div>
        <div class="type_item">
          <div>开户费/年费</div>
          <div class="i_price"><span class="pri_dollar">￥</span>{{allowancetoTalMoney ? allowancetoTalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}}</div>
          <div class="i_icon">
            <img src="../../../assets/img/subcurve6.svg" alt="">
          </div>
        </div> -->
        <div class="type_item">
          <div>通道费</div>
          <div class="i_price"><span class="pri_dollar">￥</span>{{allowancetoTalMoney ? allowancetoTalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}}</div>
          <div class="i_icon">
            <img src="../../../assets/img/subcurve1.svg" alt="">
          </div>
        </div>
        <div class="type_item">
          <div>三方支付</div>
          <div class="i_price"><span class="pri_dollar">￥</span>{{paymentTotalMoney ? paymentTotalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}}</div>
          <div class="i_icon">
            <img src="../../../assets/img/subcurve2.svg" alt="">
          </div>
        </div>
        <div class="type_item">
          <div>电子签章</div>
          <div class="i_price"><span class="pri_dollar">￥</span>{{esignTotalMoney ? esignTotalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}}</div>
          <div class="i_icon">
            <img src="../../../assets/img/subcurve3.svg" alt="">
          </div>
        </div>
        <div class="type_item">
          <div>公证</div>
          <div class="i_price"><span class="pri_dollar">￥</span>{{ notarizationTotalMoney ? notarizationTotalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0 }}</div>
          <div class="i_icon">
            <img src="../../../assets/img/subcurve4.svg" alt="">
          </div>
        </div>
      </div>
    <div class="amendment" v-if="idList.length > 0 && $hasPermission('system:capital_cost:preview')">
      <div class="select_tip">已选中 <span>{{idList.length}}</span> 条</div>
      <el-button type="primary" size="small" @click="amendment()" v-loading.fullscreen.lock="isButton">修正</el-button>
    </div>
    <el-table
        v-loading="dataListLoading"
        :data="dataList"
        style="width: 100%"
        border
        @selection-change="selectionChangeHandle"
    >
      <el-table-column v-if="$hasPermission('system:capital_cost:preview')" type="selection" header-align="center" align="center" width="50" :selectable="handleSelectable"></el-table-column>
      <el-table-column prop="userName" label="账户名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="tradingHour" label="交易时间" header-align="center" align="center"></el-table-column>
      <el-table-column prop="serialNo" label="交易流水" header-align="center" align="center"></el-table-column>
      <el-table-column prop="incomeExpenseType" label="收支类型" header-align="center" align="center"></el-table-column>
      <el-table-column prop="tradeType" label="交易类型" header-align="center" align="center"></el-table-column>
      <el-table-column prop="chargesName" label="费用名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="childrenChargesName" label="子费用名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="accrual" label="发生额" header-align="center" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.accrual != null">{{'￥'+ Number(scope.row.accrual).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableBalance" label="可用余额" header-align="center" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.availableBalance != null">{{'￥'+ Number(scope.row.availableBalance).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
        </template>
      </el-table-column>
      
      <el-table-column prop="agreementCode" label="借款编号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
      <el-table-column prop="type" label="类型" header-align="center" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 0">原始</span>
          <span v-if="scope.row.type == 1">修正</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" header-align="center" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">初始</span>
          <span v-else-if="scope.row.status == 1">处理中</span>
          <span v-else-if="scope.row.status == 2" style="color: #2cb3a3;">已修正</span>
        </template>
      </el-table-column>
      <el-table-column prop="operatorName" label="操作人" header-align="center" align="center"></el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="parseInt(total)"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
    </el-pagination>
    <el-dialog  :visible.sync="amendmentVisible" width="50%">
      <div v-if="idList.length == 1"><span v-if="modifyData.agreementCode">针对借款编号</span><span class="am_code">{{modifyData.agreementCode}}</span>(交易流水：<span  class="am_code">{{modifyData.serialNo}}</span>)的收费调整如下，请确认：</div>
      <div v-if="idList.length > 1">针对所勾选收费调整如下，请确认：</div>
      <div class="am_content">
        <div class="am_box">
          <div class="am_left"></div>
          <div class="am_right">
            <div class="am_title">待修正信息</div>
            <div class="am_item">
              <div class="am_item_title">账户名称</div>
              <div class="am_item_content">{{modifyData.originalInfo.accountName}}</div>
            </div>
            <div class="am_item" v-if="idList.length == 1">
              <div class="am_item_title">交易时间</div>
              <div class="am_item_content">{{modifyData.originalInfo.tradingHour}}</div>
            </div>
            <div class="am_item" >
              <div class="am_item_title" style="color: rgb(232,85,85);">收支类型</div>
              <div class="am_item_content" style="color: rgb(232,85,85);">{{modifyData.originalInfo.incomeExpenseType}}</div>
            </div>
            <div class="am_item">
              <div class="am_item_title">交易类型</div>
              <div class="am_item_content">{{modifyData.originalInfo.tradeType}}</div>
            </div>
            <div class="am_item">
              <div class="am_item_title">费用名称</div>
              <div class="am_item_content">{{modifyData.originalInfo.feeName}}</div>
            </div>
            <div class="am_item">
              <div class="am_item_title">子费用名称</div>
              <div class="am_item_content">{{modifyData.originalInfo.subFeeName}}</div>
            </div>
            <div>
              <div class="am_item" v-if="idList.length == 1">
                <div class="am_item_title" style="color: rgb(212,175,55);">发生额</div>
                <div class="am_item_content" style="color: rgb(212,175,55);">{{'￥'+ Number(modifyData.originalInfo.accrual).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
              </div>
              <div class="am_item"  v-else>
                <div class="am_item_title" style="color: rgb(212,175,55);">发生总额</div>
                <div class="am_item_content" style="color: rgb(212,175,55);">{{'￥'+ Number(modifyData.originalInfo.totalAccrual).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
              </div>
            </div>
            <div class="am_item" v-if="idList.length > 1" >
              <div class="am_item_title" style="color: rgb(59,70,196);">笔数</div>
              <div class="am_item_content" style="color: rgb(59,70,196);">{{ modifyData.originalInfo.count }}笔</div>
            </div>
          </div>
        </div>
        <div class="am_box">
          <div class="am_left"></div>
          <div class="am_right">
            <div class="am_title">修正后<span class="tit_tip">（系统将<span style="color: #000;">新增</span><span v-if="idList.length == 1">一笔</span>修正记录,原明细数据<span style="color: #000;">保持不变</span>）</span></div>
            <div>
              <div class="am_item" v-if="modifyData.rateCalculation == true">
                <div class="am_item_title">已收费率</div>
                <div class="am_item_content">{{modifyData.adjustedInfo.historicalRate}}%</div>
              </div>
              <div class="am_item" v-else>
                <div class="am_item_title">已收费用</div>
                <div class="am_item_content">{{'￥'+ Number(modifyData.adjustedInfo.historicalRate).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
              </div>
            </div>
            <div>
              <div class="am_item" v-if="modifyData.rateCalculation == true">
                <div class="am_item_title">当前生效费率</div>
                <div class="am_item_content">{{modifyData.adjustedInfo.currentRate}}%</div>
              </div>
              <div class="am_item" v-else>
                <div class="am_item_title">当前生效费用</div>
                <div class="am_item_content">{{'￥'+ Number(modifyData.adjustedInfo.currentRate).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
              </div>
            </div>
            
            <div>
              <div class="am_item" v-if="idList.length == 1">
                <div class="am_item_title">放款金额</div>
                <div class="am_item_content">{{'￥'+ Number(modifyData.adjustedInfo.loanAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
              </div>
              <div class="am_item" v-else>
                <div class="am_item_title">放款总额</div>
                <div class="am_item_content">{{'￥'+ Number(modifyData.adjustedInfo.totalLoanAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
              </div>
            </div>
            <div>
              <div class="am_item" v-if="modifyData.rateCalculation == true">
                <div class="am_item_title" style="color:#2cb3a3">费率差额</div>
                <div class="am_item_content"><span :style="modifyData.adjustedInfo.rateDelta < 0 ? 'color: rgb(249,7,51);' : 'color:#2cb3a3'">{{modifyData.adjustedInfo.rateDelta}}%</span>（{{modifyData.adjustedInfo.historicalRate}}%-{{modifyData.adjustedInfo.currentRate}}%） </div>
              </div>
              <div class="am_item" v-else>
                <div class="am_item_title" style="color:#2cb3a3">费用差额(元)</div>
                <div class="am_item_content"><span :style="modifyData.adjustedInfo.rateDelta < 0 ? 'color: rgb(249,7,51);' : 'color:#2cb3a3'">{{modifyData.adjustedInfo.rateDelta}}</span>（{{modifyData.adjustedInfo.historicalRate}}-{{modifyData.adjustedInfo.currentRate}}）</div>
              </div>
            </div>
            <div>
              <div class="am_item" v-if="idList.length == 1">
                <div class="am_item_title">
                  <div style="background-color: rgb(232,85,85);color: #fff;padding: 5px 6px;width: 70px;">应扣总额</div>
                </div>
                <div class="am_item_content"><span style="background-color: rgb(232,85,85);color: #fff;padding: 5px 6px;">{{'￥'+ Number(modifyData.adjustedInfo.adjustAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}} </span><span v-if="modifyData.rateCalculation == true">（{{modifyData.adjustedInfo.rateDelta}}% * {{modifyData.adjustedInfo.loanAmount}}）</span> </div>
              </div>
              <div class="am_item" v-else>
                <div class="am_item_title">
                  <div style="background-color: rgb(232,85,85);color: #fff;padding: 5px 6px;width: 70px;">应退总额</div>
                </div>
                <div class="am_item_content"><span style="background-color: rgb(232,85,85);color: #fff;padding: 5px 6px;">{{'￥'+ Number(modifyData.adjustedInfo.totalAdjustAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</span> <span v-if="modifyData.rateCalculation == true">（{{modifyData.adjustedInfo.rateDelta}}% * {{Number(modifyData.adjustedInfo.totalLoanAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}，实退金额以每条明细为准）</span> </div>
              </div>
            </div>
            <div class="am_item">
              <div class="am_item_title">收支类型</div>
              <div class="am_item_content">{{modifyData.adjustedInfo.incomeExpenseType}}</div>
            </div>
            <div class="am_item">
              <div class="am_item_title">交易类型</div>
              <div class="am_item_content">{{modifyData.adjustedInfo.tradeType}}</div>
            </div>
            <div class="am_item">
              <div class="am_item_title">费用名称</div>
              <div class="am_item_content">{{modifyData.adjustedInfo.feeName}}</div>
            </div>
            <div class="am_item">
              <div class="am_item_title">子费用名称</div>
              <div class="am_item_content">{{modifyData.adjustedInfo.subFeeName}}</div>
            </div>
            <div>
              <div v-if="idList.length == 1">
                 <div class="con_tip" v-if="modifyData.rateCalculation == true">已收费率{{modifyData.adjustedInfo.historicalRate}}%,应收费率{{modifyData.adjustedInfo.currentRate}}%，差额{{modifyData.adjustedInfo.rateDelta}}%（<span v-if="modifyData.adjustedInfo.rateDelta >0" style="color:#2cb3a3'">多收</span><span style="color: rgb(249,7,51);" v-else>少收</span>），需要资方<span v-if="modifyData.adjustedInfo.rateDelta >0" style="color:#2cb3a3'">退还款项{{modifyData.adjustedInfo.adjustAmount}}元</span><span style="color: rgb(249,7,51);" v-else>补收款项{{modifyData.adjustedInfo.adjustAmount}}元</span></div>
                <div class="con_tip" v-else>已收费用{{modifyData.adjustedInfo.historicalRate}}元，应收费用{{modifyData.adjustedInfo.currentRate}}元，差额{{modifyData.adjustedInfo.rateDelta}}元（ <span v-if="modifyData.adjustedInfo.rateDelta >0" style="color:#2cb3a3'">多收</span><span style="color: rgb(249,7,51);" v-else>少收</span>），需要资方<span v-if="modifyData.adjustedInfo.rateDelta >0" style="color:#2cb3a3'">退还款项{{modifyData.adjustedInfo.adjustAmount}}元</span><span style="color: rgb(249,7,51);" v-else>补收款项{{modifyData.adjustedInfo.adjustAmount}}元</span></div>
              </div>
              <div v-else>
                 <div class="con_tip" v-if="modifyData.rateCalculation == true">已收费率{{modifyData.adjustedInfo.historicalRate}}%,应收费率{{modifyData.adjustedInfo.currentRate}}%，差额{{modifyData.adjustedInfo.rateDelta}}%（<span v-if="modifyData.adjustedInfo.rateDelta >0" style="color:#2cb3a3'">多收</span><span style="color: rgb(249,7,51);" v-else>少收</span>），需要资方<span v-if="modifyData.adjustedInfo.rateDelta >0" style="color:#2cb3a3'">退还款项{{'￥'+ Number(modifyData.adjustedInfo.totalAdjustAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</span><span style="color: rgb(249,7,51);" v-else>补收款项{{'￥'+ Number(modifyData.adjustedInfo.totalAdjustAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</span></div>
                <div class="con_tip" v-else>已收费用{{modifyData.adjustedInfo.historicalRate}}元，应收费用{{modifyData.adjustedInfo.currentRate}}元，差额{{modifyData.adjustedInfo.rateDelta}}元（ <span v-if="modifyData.adjustedInfo.rateDelta >0" style="color:#2cb3a3'">多收</span><span style="color: rgb(249,7,51);" v-else>少收</span>），需要资方<span v-if="modifyData.adjustedInfo.rateDelta >0" style="color:#2cb3a3'">退还款项{{'￥'+ Number(modifyData.adjustedInfo.totalAdjustAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</span><span style="color: rgb(249,7,51);" v-else>补收款项{{'￥'+ Number(modifyData.adjustedInfo.totalAdjustAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</span></div>
              </div>
            </div>
            <div class="am_item" style="height: auto;">
              <div class="am_item_title" style="width: 60px;">备 注</div>
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="text_remark"
                maxlength="200"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 6}"
              >   
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <el-button @click="qx()">{{ $t('cancel') }}</el-button>
        <el-button v-loading.fullscreen.lock="isButton" type="primary" @click="confirmAmend()">{{ $t('confirm') }}</el-button>
      </template>
    </el-dialog>
    <el-dialog  :visible.sync="tipVisible" width="30%">
      <div class="tip_box_title">检测到<span>{{mulmodifyData.companyName}}</span>在以下维度待处理记录：</div>
      <div class="tip_box_fee"> {{mulmodifyData.feeName}}|{{mulmodifyData.subFeeName}}| {{mulmodifyData.feeConditionName}} | {{mulmodifyData.feeCondition}} | {{mulmodifyData.rateCalculation == true ? mulmodifyData.feeAmount + '%' : '￥'+ Number(mulmodifyData.feeAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}} </div>
      <div class="tip_box_item">
        <div class="i_dot"></div>
        <div class="i_text">总明细数：{{mulmodifyData.totalCount}}条</div>
      </div>
      <div class="tip_box_item">
        <div class="i_dot"></div>
        <div class="i_text">已选调整：{{mulmodifyData.selectedCount}}条</div>
      </div>
      <div class="tip_box_item">
        <div class="i_dot"></div>
        <div class="i_text">待处理剩余：{{mulmodifyData.pendingCount}}条</div>
      </div>
      <div class="select_tip1">
        请选择操作方式：
      </div>
      <template slot="footer">
        <el-button @click="qx()">全部取消</el-button>
        <el-button type="primary"  plain @click="allChange">全量覆盖调整</el-button>
        <el-button type="primary" @click="onlyChange">仅调整已选项</el-button>
      </template>
    </el-dialog>
  </el-card>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  
  data() {
    return {
      text_remark:'',
      isButton:false,
      tipVisible:false,
      amendmentVisible:false,
      date:null,
      fundList:[],
      incomeTypeList:[],
      payTypeList:[],
      feeTypeList:[],
      feeTypeChildrenList:[],
      idList:[],
      typeList:[
        {
          value: 0,
          label: '原始'
        },
        {
          value: 1,
          label: '修正'
        }
      ],
      statusList:[
        {
          value: 0,
          label: '初始'
        },
        {
          value: 1,
          label: '处理中'
        },
        {
          value: 2,
          label: '已修正'
        }
      ],
      modifyData:{
        "snapshotSign": "",
        "serialNo": "",
        "agreementCode": "",
        "originalInfo": {
            "accountName": "",
            "tradingHour": "",
            "incomeExpenseType": "",
            "tradeType": "",
            "feeName": "",
            "subFeeName": "",
            "accrual": null
        },
        "adjustedInfo": {
            "historicalRate": null,
            "currentRate": null,
            "loanAmount": null,
            "rateDelta":null,
            "adjustAmount": null,
            "incomeExpenseType": "",
            "tradeType": "",
            "feeName": "",
            "subFeeName": "",
            "remark": null
        },
        "rateCalculation": false
      },
      mulmodifyData:{
        "companyName": "",
        "feeName": "",
        "subFeeName": "",
        "feeConditionName": "",
        "feeCondition": "",
        "totalCount": null,
        "selectedCount":null,
        "pendingCount": null,
        "selectedPreview": {
            "snapshotSign": "",
            "originalSummary": {
                "accountName": "",
                "incomeExpenseType": "",
                "tradeType": "",
                "feeName": "",
                "subFeeName": "",
                "totalAccrual": null,
                "count": null
            },
            "adjustedSummary": {
                "historicalRate": null,
                "currentRate": null,
                "totalLoanAmount": null,
                "rateDelta": null,
                "totalAdjustAmount": null,
                "incomeExpenseType": "",
                "tradeType": "",
                "feeName": "",
                "subFeeName": "",
                "remark": null
            },
            "correctionItems": null,
            "newCostData": null,
            "fullBilling": null,
            "rateCalculation": null
        },
        "fullPreview": {
            "snapshotSign": "",
            "originalSummary": {
                "accountName": "",
                "incomeExpenseType": "",
                "tradeType": "",
                "feeName": "",
                "subFeeName": "",
                "totalAccrual": null,
                "count": null
            },
            "adjustedSummary": {
                "historicalRate": null,
                "currentRate": null,
                "totalLoanAmount": null,
                "rateDelta": null,
                "totalAdjustAmount": null,
                "incomeExpenseType": "",
                "tradeType": "",
                "feeName": "",
                "subFeeName": "",
                "remark": null
            },
            "correctionItems": null,
            "newCostData": null,
            "fullBilling": null,
            "rateCalculation": null
        },
        "fullBilling": null
      },
      allowancetoTalMoney:'',
      paymentTotalMoney:'',
      esignTotalMoney:'',
      notarizationTotalMoney:'',
      mixinViewModuleOptions: {
        getDataListURL: `/system/capital_cost/pageList`,
        getDataListIsPage: true,
        multilist:true,
      },
    } 
  },
  watch: {
    $route: {
      handler(newVal, odlVal) {
        if (newVal.path === "/loan-expenditure") {
          this.getInfo()
          this.getDataList()
        } 
      },
      deep: true,
      immediate: true,
    },
  },
  created(){
    if(this.$route.query && this.$route.query.month){
      const today = new Date();
      const currentMonth = today.getMonth() + 1;
      const currentYear = today.getFullYear();
      const startDate = new Date(currentYear, currentMonth - 1, 1);
      const endDate = new Date(currentYear, currentMonth, 0);
      this.date = [startDate, endDate]
      this.dataForm = {
        ...this.dataForm,
        startTime:this.formatDate(startDate),
        endTime:this.formatDate(endDate.setHours(23, 59, 59, 999)),
        chargesId:'1'
      }
      this.getDataList()
      this.getInfo()
    }else{
      this.getDataList()
      this.getInfo()
    }
    this.$http.get('/sys/user/queryUserIdList').then(res=>{
        this.fundList = res.data.data
    })
    this.$http.get(`/sys/dict/data/list?dataType=income_expenses`).then(r=>{
      this.incomeTypeList = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []    
    })
    this.$http.get(`/sys/dict/data/list?dataType=pay_type`).then(r=>{
      this.payTypeList = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []    
    })
    this.$http.get('/system/serviceFeesType/list/1').then(res=>{
      this.feeTypeList = res.data.data || []
    })
    this.$http.get(`/system/serviceFeesType/list/0`).then(res=>{
      this.feeTypeChildrenList = res.data.data || []
    })

    this.$http.get('sys/user/info').then(res=>{
      if(res.data.code != 0){
        return this.$message.error(res.data.msg)
      }
    })


  },
  methods:{
    getInfo(){
      this.$http.get('system/capital_cost/fetchRealTimeDetails',{
        params:{
          ...this.dataForm
        }
      }).then(res=>{
        if(res.data.code != 0){
          return this.$message.error(res.data.msg)
        }
        this.allowancetoTalMoney = res.data.data.allowancetoTalMoney
        this.paymentTotalMoney = res.data.data.paymentTotalMoney
        this.esignTotalMoney = res.data.data.esignTotalMoney
        this.notarizationTotalMoney = res.data.data.notarizationTotalMoney
        
      })
    },
    formatDate(dateString) {
      const dateObj = new Date(dateString);
      const year = dateObj.getFullYear();
      const month = this.addLeadingZero(dateObj.getMonth() + 1);
      const day = this.addLeadingZero(dateObj.getDate());
      const hours = this.addLeadingZero(dateObj.getHours());
      const minutes = this.addLeadingZero(dateObj.getMinutes());
      const seconds = this.addLeadingZero(dateObj.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    addLeadingZero(num) {
      return num < 10 ? `0${num}` : num;
    },
    getTimes() {
        if (this.date != null) {
          this.dataForm.startTime = this.date[0]
          this.dataForm.endTime = this.date[1]
        }else{
          this.dataForm.startTime =''
          this.dataForm.endTime = ''
        }
    },
    inquire(){
      this.getDataList('dept')
      this.getInfo()
    },
    onlyChange(){
      this.modifyData = this.mulmodifyData.selectedPreview
      this.amendmentVisible = true
      this.tipVisible = false
    },
    allChange(){
      this.modifyData = this.mulmodifyData.fullPreview
      this.amendmentVisible = true
      this.tipVisible = false
    },
    amendment(){
      this.isButton = true
      this.$http.post('system/capital_cost/preview',{
        detailIds:this.idList
      }).then(res=>{
        this.isButton = false
        if(res.data.code != 0){
          return this.$message.error(res.data.msg)
        }
        if(this.idList.length == 1){
          this.modifyData = res.data.data
          this.amendmentVisible = true
        }else{
          this.mulmodifyData = res.data.data
          if(res.data.data.fullBilling == false){
            this.tipVisible = true
          }else{
            this.modifyData = res.data.data
            this.amendmentVisible = true
          }
        }
      })
    },
    qx(){
      this.tipVisible = false
      this.amendmentVisible = false
      this.text_remark = ''
    },
    confirmAmend(){
      this.isButton = true
      this.$http.put('system/capital_cost/singleOrBatch',{
        snapshotSign:this.modifyData.snapshotSign,
        remark:this.text_remark
      }).then(res=>{
        this.isButton = false
        if(res.data.code != 0){
          return this.$message.error(res.data.msg)
        }
         this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.amendmentVisible = false
                  this.getDataList()
                  this.text_remark = ''
                },
              })
     
        
      })
    },
    handleSelectable(row, index) {
      if(row.status == 2 || ((row.tradeType == '退款' || row.tradeType == '提现' || row.tradeType == '充值') && row.type == 0)){
        return false
      }
      return true
    },
    selectionChangeHandle (val) {
      this.idList = val.map(item=>item.id)
    },
  }
}
</script>
<style scoped lang="scss">
  .type{
    display: flex;
    justify-content: space-between;
    padding: 30px 0;
    .sum_amount{
      background-color: #2cb3a3;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      padding: 0 20px;
      .number{
        font-size: 36px;
        margin-bottom: 20px;
      }
      .text{
        font-size: 17px;
      }
    }
    .type_item{
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      .i_price{
        font-size: 30px;
        margin-top: 20px;
      }
      .i_icon{
        width: 120px;
        img{
          width: 100%;
        }
      }
    }
  }
  .pri_dollar{
    font-size: 22px;
    position: relative;
    bottom: 3px;
    font-weight: normal;
  }
  .amendment{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .select_tip{
      margin:0 10px;
      font-weight: bold;
      font-size: 15px;
      span{
        color: #2cb3a3;
      }
    }
  }
  .am_content{
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-top: 30px;
    .am_box{
      display: flex;
      margin-right: 20px;
      .am_left{
        width: 10px;
        height: 16px;
        background-color: #2cb3a3;
        margin-right: 10px;
      }
      .am_right{
        .am_title{
          font-size: 16px;
          font-weight: bold;
          color: #000;
          margin-bottom: 20px;

        }
        .tit_tip{
          font-size: 14px;
          color: #999;
          font-weight: normal;
        }
        .am_item{
          display: flex;
          align-items: center;
          height: 34px;
          .am_item_title{
            font-weight: bold;
            color: #000;
            width: 120px;
          }
          .am_item_content{
            color: #666;
            font-size: 14px;
          }
        }
        .con_tip{
          background-color: rgb(254,243,228);
          color: rgb(245,135,7);
          font-weight: bold;
          padding: 6px 10px 4px;
          margin-bottom: 20px;
          font-size: 12px;
        }
      }
    }
  }
  .am_code{
    font-weight: bold;
    color: #000;
  }
  .tip_box_title{
    margin-bottom: 30px;
    span{
      color: #333;
      font-weight: bold;
      font-size: 15px;
    }
  }
  .tip_box_fee{
    color: rgb(45, 183, 132);
    margin-left: 60px;
  }
  .tip_box_item{
    display: flex;
    align-items: center;
    margin-top: 16px;
    margin-left: 60px;
    
    .i_dot{
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: rgb(63, 65, 146);
      margin-right: 10px;

    }
    .i_text{
      font-size: 14px;
      color: rgb(133,157,169);
    }
  }
  .select_tip1{
    font-size: 15px;
    font-weight: bold;
    color: rgb(63, 65, 146);
    margin-top: 30px;
    margin-right:50%;
    text-align: right;
  }
</style>